import { FetchState } from '@/types/fetchState';
import { defineStore } from 'pinia';
import { generateAPI } from '@/shared/lib';

interface TelemeterState {
  baseTime: number;
  observatories: {
    [key: string]: {
      obsTime: number;
      bsnRain10m: number;
      bsnRainInc: number;
      noRainPeriod: number;
    }[];
  };
}

/**
 * @description 4日ずらした日付を返す
 * @param yyyymmddhhmm
 */
const getFourDaysAgo = (yyyymmddhhmm: string) => {
  // "YYYYMMDDHHmm" → Date に変換
  const year = parseInt(yyyymmddhhmm.slice(0, 4), 10);
  const month = parseInt(yyyymmddhhmm.slice(4, 6), 10) - 1; // 月は0始まり
  const day = parseInt(yyyymmddhhmm.slice(6, 8), 10);
  const hour = parseInt(yyyymmddhhmm.slice(8, 10), 10);
  const minute = parseInt(yyyymmddhhmm.slice(10, 12), 10);

  const date = new Date(year, month, day, hour, minute);

  date.setDate(date.getDate() + 4);

  // フォーマットして返す
  const pad = (n) => n.toString().padStart(2, '0');
  const result = date.getFullYear().toString()
    + pad(date.getMonth() + 1)
    + pad(date.getDate())
    + pad(date.getHours())
    + pad(date.getMinutes());

  return result;
};

export const useTelemeterBasinStore = defineStore('telemeterBasin', {
  state: (): FetchState<TelemeterState> => ({
    data: null,
    loading: false,
    error: null,
  }),
  getters: {
    observatories: (state) => state.data?.observatories ?? null,
  },
  actions: {
    async fetch({
      code,
      baseTime,
      hours = 96,
      interval = '10m',
      raintype = 'cband',
    }: {
      code: string;
      baseTime: string;
      hours?: number;
      interval?: string;
      raintype?: string;
    }) {
      this.loading = true;
      try {
        this.data = await generateAPI().systemApi.fetchTelemeterBasinApiTelemeterBasinTargetGet({
          target: 'dam',
          id: code,
          dateTime: getFourDaysAgo(baseTime),
          hours: hours.toString(),
          interval,
          raintype,
        });
      } catch (error) {
        this.error = error as Error;
        throw error;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.data = null;
      this.loading = false;
      this.error = null;
    },
  },
});
